"use client";

import { DietCardDesktop } from "@/features/cart/components/configure-diet/diet-card/diet-card-desktop";
import { DietCardMobile } from "@/features/cart/components/configure-diet/diet-card/diet-card-mobile";
import type { OmnibusConfiguredPrices } from "@/features/diets/helpers/omnibus";
import type { DietCatalogDetail } from "@/features/diets/types";
import type { Globals } from "@/features/globals/types/globals.type";

export const DietConfigurationCard = ({
  diet,
  globals,
  variant,
  kcal,
  menuPrices,
}: {
  diet: DietCatalogDetail;
  globals?: Globals | null;
  variant?: string;
  kcal?: string;
  // Prices of the menu preview header (MPL-1835).
  menuPrices?: OmnibusConfiguredPrices;
}) => (
  <>
    <div className="hidden md:block">
      <DietCardDesktop
        diet={diet}
        globals={globals}
        kcal={kcal}
        menuPrices={menuPrices}
        variant={variant}
      />
    </div>
    <div className="block md:hidden">
      <DietCardMobile
        diet={diet}
        globals={globals}
        kcal={kcal}
        menuPrices={menuPrices}
        variant={variant}
      />
    </div>
  </>
);
